/**
 * Konfigurasi role, dashboard, dan hak akses route.
 * Sinkron dengan ENUM role di backend (models/Admin.js).
 */

export const ROLES = {
  ADMIN: 'admin',
  SURVEYOR: 'surveyor',
  VERIFIKATOR: 'verifikator',
  INPUTDATA: 'inputdata',
  AGR: 'AGR',
  TFL: 'TFL',
  KOORDINATOR_TFL: 'Koordinator TFL',
  FASILITATOR: 'fasilitator',
  SUPPLIER: 'Supplier Penyedia',
  PPK: 'PPK',
  KABID: 'Kabid',
  KADIS: 'Kadis',
  BUPATI: 'Bupati',
  KEPALA_DINAS: 'kepaladinas',
  PENERIMABANTUAN: 'PenerimaBantuan',
};

export const ROLE_META = {
  [ROLES.ADMIN]: {
    label: 'Administrator',
    description: 'Pengelola penuh sistem pendataan dan bantuan perumahan.',
    dashboard: '/admin/dashboard',
    color: '#0A5EB0',
  },
  [ROLES.SURVEYOR]: {
    label: 'Surveyor',
    description: 'Pendataan kualitas rumah di lapangan.',
    dashboard: '/admin/dashboard',
    color: '#1565C0',
  },
  [ROLES.VERIFIKATOR]: {
    label: 'Verifikator',
    description: 'Validasi data pembangunan baru.',
    dashboard: '/admin/dashboard',
    color: '#2E7D32',
  },
  [ROLES.INPUTDATA]: {
    label: 'Input Data',
    description: 'Penginputan register usulan bantuan.',
    dashboard: '/admin/dashboard',
    color: '#6A1B9A',
  },
  [ROLES.AGR]: {
    label: 'AGR — Agen Gotong Royong',
    description: 'Pelaksana fisik lapangan: unggah laporan tahapan progres rumah.',
    dashboard: '/agr/dashboard',
    color: '#2E7D32',
  },
  [ROLES.TFL]: {
    label: 'TFL — Tenaga Fasilitator Lapangan',
    description: 'Pengawas desa: validasi data, pengawalan dokumen, mediasi kendala.',
    dashboard: '/tfl/dashboard',
    color: '#00838F',
  },
  [ROLES.KOORDINATOR_TFL]: {
    label: 'Koordinator TFL',
    description: 'Koordinator wilayah: validasi langkah bantuan & memantau TFL per kecamatan.',
    dashboard: '/koordinator-tfl/dashboard',
    color: '#00695C',
  },
  [ROLES.FASILITATOR]: {
    label: 'Fasilitator',
    description: 'Memfasilitasi proses bantuan dan monitoring pelaksanaan.',
    dashboard: '/fasilitator/dashboard',
    color: '#EF6C00',
  },
  [ROLES.SUPPLIER]: {
    label: 'Toko Penyedia (Supplier)',
    description: 'Toko material: perbarui status pengiriman barang dan faktur.',
    dashboard: '/supplier/dashboard',
    color: '#5D4037',
  },
  [ROLES.PPK]: {
    label: 'PPK',
    description: 'Otorisasi teknis & keuangan: persetujuan pemindahbukuan dan pencairan upah.',
    dashboard: '/ppk/dashboard',
    color: '#283593',
  },
  [ROLES.KABID]: {
    label: 'Kabid',
    description: 'Otorisasi teknis & keuangan bidang terkait.',
    dashboard: '/kabid/dashboard',
    color: '#4527A0',
  },
  [ROLES.KADIS]: {
    label: 'Kadis',
    description: 'Dashboard eksekutif: sebaran peta, realisasi anggaran, penanganan masalah.',
    dashboard: '/kadis/dashboard',
    color: '#1B5E20',
  },
  [ROLES.BUPATI]: {
    label: 'Bupati',
    description: 'Dashboard eksekutif wilayah: monitoring capaian program perumahan.',
    dashboard: '/bupati/dashboard',
    color: '#B71C1C',
  },
  [ROLES.KEPALA_DINAS]: {
    label: 'Kepala Dinas',
    description: 'Dashboard eksekutif dinas: peta sebaran, realisasi, kecepatan penanganan.',
    dashboard: '/kepaladinas/dashboard',
    color: '#004D40',
  },
  [ROLES.PENERIMABANTUAN]: {
    label: 'Penerima Bantuan',
    description: 'Penerima bantuan rumah layak huni.',
    dashboard: '/penerima/dashboard',
    color: '#FF5722',
  }
};

/** Hak akses per path — role yang boleh membuka route */
export const ROUTE_ACCESS = {
  '/admin/dashboard': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.VERIFIKATOR, ROLES.INPUTDATA],
  '/agr/dashboard': [ROLES.AGR],
  '/tfl/dashboard': [ROLES.TFL],
  '/koordinator-tfl/dashboard': [ROLES.KOORDINATOR_TFL],
  '/koordinator-tfl/monitoring': [ROLES.KOORDINATOR_TFL, ROLES.ADMIN, ROLES.KABID, ROLES.KADIS, ROLES.BUPATI],
  '/fasilitator/dashboard': [ROLES.FASILITATOR],
  '/supplier/dashboard': [ROLES.SUPPLIER],
  '/ppk/dashboard': [ROLES.PPK],
  '/kabid/dashboard': [ROLES.KABID],
  '/kadis/dashboard': [ROLES.KADIS],
  '/bupati/dashboard': [ROLES.BUPATI],
  '/kepaladinas/dashboard': [ROLES.KEPALA_DINAS],
  '/penerima/dashboard': [ROLES.PENERIMABANTUAN],
  '/penerima/tindak-lanjut': [ROLES.PENERIMABANTUAN],

  '/register': [ROLES.ADMIN],
  '/registerdata': [ROLES.ADMIN, ROLES.INPUTDATA],
  '/rekapdatabantuanrumah': [ROLES.ADMIN, ROLES.INPUTDATA, ROLES.BUPATI],
  '/recap': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.BUPATI, ROLES.KADIS, ROLES.KEPALA_DINAS],
  '/recapVerifikasi': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.VERIFIKATOR, ROLES.TFL, ROLES.FASILITATOR, ROLES.BUPATI, ROLES.KADIS, ROLES.KEPALA_DINAS],
  '/questionnaire': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.BUPATI, ROLES.KADIS, ROLES.KEPALA_DINAS],
  '/questionnaire/:id': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.BUPATI, ROLES.KADIS, ROLES.KEPALA_DINAS],
  '/upload': [ROLES.ADMIN, ROLES.SURVEYOR],
  '/uploadpdf': [ROLES.ADMIN],
  '/userlist': [ROLES.ADMIN],
  '/maps': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.KEPALA_DINAS, ROLES.KADIS, ROLES.BUPATI, ROLES.PPK, ROLES.KABID],
  '/Verifikasi': [ROLES.ADMIN, ROLES.SURVEYOR, ROLES.VERIFIKATOR, ROLES.FASILITATOR],
  '/backlog': [ROLES.ADMIN, ROLES.SURVEYOR],
  '/data-upah-tukang': [ROLES.ADMIN, ROLES.AGR, ROLES.TFL, ROLES.FASILITATOR, ROLES.PPK, ROLES.KABID, ROLES.KADIS, ROLES.KEPALA_DINAS, ROLES.BUPATI],
  '/data-bantuan': [ROLES.ADMIN, ROLES.INPUTDATA, ROLES.TFL, ROLES.FASILITATOR, ROLES.PPK, ROLES.KABID, ROLES.BUPATI, ROLES.KOORDINATOR_TFL],
  '/data-bantuan/tambah': [ROLES.ADMIN, ROLES.INPUTDATA, ROLES.TFL, ROLES.FASILITATOR, ROLES.PPK, ROLES.KABID, ROLES.BUPATI, ROLES.KOORDINATOR_TFL],
  '/data-sk': [ROLES.ADMIN],
  '/proses-bantuan': [ROLES.ADMIN, ROLES.AGR, ROLES.FASILITATOR, ROLES.TFL, ROLES.BUPATI, ROLES.KOORDINATOR_TFL, ROLES.KADIS, ROLES.KEPALA_DINAS],
  '/monitoring-bantuan': [ROLES.ADMIN, ROLES.TFL, ROLES.AGR, ROLES.FASILITATOR, ROLES.PPK, ROLES.KABID, ROLES.KEPALA_DINAS, ROLES.KADIS, ROLES.BUPATI, ROLES.KOORDINATOR_TFL],
  '/presentase-bantuan': [ROLES.ADMIN, ROLES.AGR, ROLES.FASILITATOR, ROLES.TFL, ROLES.BUPATI, ROLES.KADIS, ROLES.KEPALA_DINAS],
  '/rekap-bantuan': [ROLES.ADMIN, ROLES.PPK, ROLES.KABID, ROLES.KEPALA_DINAS, ROLES.KADIS, ROLES.BUPATI],
  '/keluhan': [ROLES.ADMIN, ROLES.AGR, ROLES.TFL, ROLES.FASILITATOR, ROLES.PPK, ROLES.KABID, ROLES.KADIS, ROLES.KEPALA_DINAS, ROLES.BUPATI],

  '/data-supplier': [ROLES.ADMIN, ROLES.SUPPLIER, ROLES.TFL],
  '/data-pembelian-supplier': [ROLES.ADMIN, ROLES.SUPPLIER, ROLES.PPK, ROLES.KABID, ROLES.TFL],
  '/input-pembelian': [ROLES.ADMIN, ROLES.TFL],
  '/laporan-rab-supplier': [ROLES.ADMIN, ROLES.TFL, ROLES.SUPPLIER, ROLES.BUPATI],
  '/rekap-transaksi-bantuan': [ROLES.ADMIN, ROLES.TFL, ROLES.PPK, ROLES.KABID, ROLES.BUPATI],
  '/nota-pengiriman':[ROLES.ADMIN, ROLES.TFL, ROLES.PPK, ROLES.KABID, ROLES.BUPATI, ROLES.SUPPLIER], // DEPRECATED — merged into /supplier/pengiriman/:id
  '/supplier/bukti-transfer':[ROLES.SUPPLIER, ROLES.ADMIN],
  '/supplier/pengiriman/:id':[ROLES.SUPPLIER, ROLES.ADMIN, ROLES.TFL, ROLES.PPK, ROLES.KABID],
  '/supplier/penagihan':[ROLES.SUPPLIER, ROLES.ADMIN, ROLES.TFL, ROLES.PPK, ROLES.KABID, ROLES.KADIS, ROLES.AGR],
  '/admin/backup-restore': [ROLES.ADMIN],
};

/** Menu sidebar per role */
export const ROLE_SIDEBAR = {
  [ROLES.ADMIN]: [
    { to: '/admin/dashboard', text: 'Dashboard' },
    { to: '/registerdata', text: 'Register Usulan' },
    { to: '/rekapdatabantuanrumah', text: 'Rekap Usulan Bantuan Rumah' },
    { to: '/recap', text: 'Rekapitulasi' },
    { to: '/recapVerifikasi', text: 'Data Verifikasi' },
    { to: '/maps', text: 'Sebaran Lokasi' },
    { to: '/upload', text: 'Upload Foto Manual' },
    { to: '/backlog', text: 'Data Backlog' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
    { to: '/data-sk', text: 'Data SK Penetapan' },
     { to: '/koordinator-tfl/monitoring', text: 'Monitoring TFL' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/rekap-bantuan', text: 'Rekap Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/presentase-bantuan', text: 'Presentase Bantuan' },
    { to: '/keluhan', text: 'Keluhan' },
    { to: '/data-supplier', text: 'Data Supplier' },
    { to: '/input-pembelian', text: 'Input Pembelian' },
    { to: '/data-pembelian-supplier', text: 'Pembelian Supplier' },
    { to: '/supplier/penagihan', text: 'Penagihan Supplier' },
    // { to: '/laporan-rab-supplier', text: 'Laporan RAB' },
    { to: '/rekap-transaksi-bantuan', text: 'Rekap Transaksi Bantuan' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    // Nota Pengiriman digabung ke halaman Pengiriman Supplier
    { to: '/register', text: 'Register User' },
    { to: '/uploadpdf', text: 'Upload PDF' },
    { to: '/userlist', text: 'User List' },
    { to: '/admin/backup-restore', text: 'Backup & Restore DB' },
  ],
  [ROLES.INPUTDATA]: [
    { to: '/admin/dashboard', text: 'Dashboard' },
    { to: '/registerdata', text: 'Register Usulan' },
    { to: '/rekapdatabantuanrumah', text: 'Rekap Usulan Bantuan Rumah' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
  ],
  [ROLES.SURVEYOR]: [
    { to: '/admin/dashboard', text: 'Dashboard' },
    { to: '/recap', text: 'Rekapitulasi' },
    { to: '/recapVerifikasi', text: 'Data Verifikasi' },
    { to: '/maps', text: 'Sebaran Lokasi' },
    { to: '/upload', text: 'Upload Foto Manual' },
    { to: '/backlog', text: 'Data Backlog' },
    { to: '/questionnaire', text: 'Pendataan Rehab' },
    { to: '/Verifikasi', text: 'Validasi PB' },
  ],
  [ROLES.VERIFIKATOR]: [
    { to: '/admin/dashboard', text: 'Dashboard' },
    { to: '/recapVerifikasi', text: 'Data Verifikasi' },
    { to: '/Verifikasi', text: 'Input Verifikasi' },
  ],
  [ROLES.AGR]: [
    { to: '/agr/dashboard', text: 'Dashboard' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/supplier/penagihan', text: 'Penagihan Supplier' },
    { to: '/presentase-bantuan', text: 'Presentase & Laporan' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/keluhan', text: 'Keluhan' },
  ],
  [ROLES.TFL]: [
    { to: '/tfl/dashboard', text: 'Dashboard' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
    { to: '/input-pembelian', text: 'Input Pembelian' },
    // { to: '/laporan-rab-supplier', text: 'Laporan RAB' },
    { to: '/data-pembelian-supplier', text: 'Pembelian Supplier' },
    { to: '/supplier/penagihan', text: 'Penagihan Supplier' },
    { to: '/rekap-transaksi-bantuan', text: 'Rekap Transaksi Bantuan' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/keluhan', text: 'Mediasi Keluhan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/data-supplier', text: 'Data Supplier' },
    // { to: '/userlist', text: 'Kelola Akun' },
  ],
  [ROLES.FASILITATOR]: [
    { to: '/fasilitator/dashboard', text: 'Dashboard' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/presentase-bantuan', text: 'Presentase' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
    { to: '/keluhan', text: 'Keluhan' },
  ],
  [ROLES.KOORDINATOR_TFL]: [
    { to: '/koordinator-tfl/dashboard', text: 'Dashboard' },
    { to: '/koordinator-tfl/monitoring', text: 'Monitoring TFL' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
  ],
  [ROLES.SUPPLIER]: [
    { to: '/supplier/dashboard', text: 'Dashboard' },
    { to: '/laporan-rab-supplier', text: 'RAB Penerima Bantuan' },
    { to: '/data-pembelian-supplier', text: 'Pembelian Supplier' },
    { to: '/supplier/penagihan', text: 'Penagihan' },
    { to: '/supplier/bukti-transfer', text: 'Bukti Transfer' },
    { to: '/data-supplier', text: 'Data Supplier' },
    // Nota Pengiriman digabung ke halaman Pengiriman Supplier
  ],
  [ROLES.PPK]: [
    { to: '/ppk/dashboard', text: 'Dashboard' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/rekap-bantuan', text: 'Rekap & Anggaran' },
    { to: '/data-pembelian-supplier', text: 'Faktur Material' },
    { to: '/supplier/penagihan', text: 'Penagihan Supplier' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/keluhan', text: 'Keluhan' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
  ],
  [ROLES.KABID]: [
    { to: '/kabid/dashboard', text: 'Dashboard' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/rekap-bantuan', text: 'Rekap & Anggaran' },
    { to: '/data-pembelian-supplier', text: 'Faktur Material' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/keluhan', text: 'Keluhan' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
  ],
  [ROLES.KADIS]: [
    { to: '/kadis/dashboard', text: 'Dashboard Eksekutif' },
    { to: '/maps', text: 'Peta Sebaran' },
    { to: '/recap', text: 'Data Pendataan Rumah' },
    { to: '/recapVerifikasi', text: 'Data Verifikasi' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/presentase-bantuan', text: 'Presentase Bantuan' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/rekap-bantuan', text: 'Realisasi Anggaran' },
    { to: '/keluhan', text: 'Penanganan Masalah' },
  ],
  [ROLES.BUPATI]: [
    { to: '/bupati/dashboard', text: 'Dashboard Eksekutif' },
    { to: '/maps', text: 'Peta Sebaran' },
    { to: '/rekapdatabantuanrumah', text: 'Rekap Usulan Bantuan Rumah' },
    { to: '/recap', text: 'Data Pendataan Rumah' },
    { to: '/recapVerifikasi', text: 'Data Verifikasi' },
    { to: '/data-bantuan', text: 'Data Penerima Bantuan' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/presentase-bantuan', text: 'Presentase Bantuan' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/rekap-bantuan', text: 'Realisasi Anggaran' },
    { to: '/keluhan', text: 'Penanganan Masalah' },
  ],
  [ROLES.KEPALA_DINAS]: [
    { to: '/kepaladinas/dashboard', text: 'Dashboard Eksekutif' },
    { to: '/maps', text: 'Peta Sebaran' },
    { to: '/recap', text: 'Data Pendataan Rumah' },
    { to: '/recapVerifikasi', text: 'Data Verifikasi' },
    { to: '/monitoring-bantuan', text: 'Monitoring Bantuan' },
    { to: '/proses-bantuan', text: 'Proses Bantuan' },
    { to: '/presentase-bantuan', text: 'Presentase Bantuan' },
    { to: '/data-upah-tukang', text: 'Data Upah Tukang' },
    { to: '/rekap-bantuan', text: 'Realisasi Anggaran' },
    { to: '/keluhan', text: 'Penanganan Masalah' },
  ],
  [ROLES.PENERIMABANTUAN]: [
    { to: '/penerima/dashboard', text: 'Dashboard' },
    { to: '/penerima/tindak-lanjut', text: 'Monitoring Tindak Lanjut' },
  ],
};

export function getDashboardPath(role) {
  return ROLE_META[role]?.dashboard || '/login';
}

export function canAccessRoute(role, path) {
  const normalized = path.split('?')[0].replace(/\/$/, '') || '/';
  const withParams = Object.keys(ROUTE_ACCESS).find((key) => {
    if (key.includes(':')) {
      const pattern = key.replace(/:[^/]+/g, '[^/]+');
      return new RegExp(`^${pattern}$`).test(normalized);
    }
    return key === normalized;
  });
  const allowed = ROUTE_ACCESS[withParams || normalized];
  if (!allowed) return role === ROLES.ADMIN;
  return allowed.includes(role);
}

export function getSidebarItems(role) {
  return ROLE_SIDEBAR[role] || [{ to: getDashboardPath(role), text: 'Dashboard' }];
}

// ============================================================
// PERBAIKAN: getQuickLinks dengan safe checking
// ============================================================
export function getQuickLinks(role) {
  try {
    // Ambil sidebar items untuk role
    const items = getSidebarItems(role) || [];
    
    // Filter: hanya ambil yang memiliki 'to' dan tidak berakhir dengan 'dashboard'
    const filtered = items.filter((item) => {
      // Pastikan item ada dan memiliki properti 'to'
      if (!item || typeof item !== 'object') return false;
      if (!item.to || typeof item.to !== 'string') return false;
      // Cek apakah path berakhir dengan 'dashboard'
      return !item.to.endsWith('/dashboard');
    });
    
    // Ambil maksimal 6 item
    return filtered.slice(0, 6);
  } catch (error) {
    console.error('Error in getQuickLinks:', error);
    return [];
  }
}

// ============================================================
// PERBAIKAN: getQuickLinksWithIcon (untuk dashboard)
// ============================================================
export function getQuickLinksWithIcon(role) {
  const links = getQuickLinks(role);
  
  // Map icon berdasarkan path
  const iconMap = {
    '/data-bantuan': 'HomeWork',
    '/monitoring-bantuan': 'Assessment',
    '/proses-bantuan': 'Engineering',
    '/koordinator-tfl/monitoring': 'SupervisorAccount',
    '/rekap-bantuan': 'Analytics',
    '/keluhan': 'ReportProblem',
    '/data-supplier': 'Store',
    '/input-pembelian': 'ShoppingCart',
    '/data-pembelian-supplier': 'Receipt',
    '/laporan-rab-supplier': 'Description',
    '/rekap-transaksi-bantuan': 'ReceiptLong',
    '/data-upah-tukang': 'Person',
    '/maps': 'LocationOn',
    '/registerdata': 'ListAlt',
    '/recap': 'TableChart',
    '/recapVerifikasi': 'Verified',
    '/upload': 'UploadFile',
    '/backlog': 'Pending',
    '/presentase-bantuan': 'PieChart',
    '/status-bantuan': 'HomeWork',
    '/progres-bantuan': 'Timeline',
  };
  
  return links.map(item => ({
    ...item,
    icon: iconMap[item.to] || 'Dashboard'
  }));
}
